import { ChevronDown, Search } from 'lucide-react'
import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase/client'
import { NotificationBell } from '@/features/notifications/components/notification-bell'

interface TopBarProps {
  projectId?: string
  showProject?: boolean
}

async function fetchProjectMeta(projectId: string) {
  const { data } = await supabase
    .from('projects')
    .select('name, code')
    .eq('id', projectId)
    .single()
  return data
}

export function TopBar({ projectId, showProject = true }: TopBarProps) {
  const { data: project } = useQuery({
    queryKey: ['project-meta', projectId],
    queryFn: () => fetchProjectMeta(projectId!),
    enabled: !!projectId && showProject,
    staleTime: 10 * 60 * 1000,
  })

  return (
    <header className="h-14 bg-card border-b border-border flex items-center px-4 gap-3 shrink-0 z-10">
      <div className="flex items-center gap-2 me-2">
        <div className="w-8 h-8 rounded-md bg-primary flex items-center justify-center shrink-0">
          <span className="text-primary-foreground font-bold text-sm font-mono">M</span>
        </div>
        <span className="text-sm font-semibold text-foreground hidden sm:inline">MedRegistry</span>
      </div>

      {showProject && <div className="h-5 w-px bg-border mx-1" />}

      {showProject && (
        <Link to="/projects">
          <Button
            variant="ghost"
            size="sm"
            className="gap-1.5 text-sm font-medium text-foreground hover:bg-muted px-2.5"
          >
            {project?.code && (
              <span className="text-xs font-mono text-muted-foreground bg-muted px-1.5 py-0.5 rounded">
                {project.code}
              </span>
            )}
            <span className="max-w-40 truncate">
              {project?.name ?? 'انتخاب پروژه'}
            </span>
            <ChevronDown className="w-3.5 h-3.5 text-muted-foreground shrink-0" />
          </Button>
        </Link>
      )}

      <div className="flex-1" />

      <Button
        variant="ghost"
        size="sm"
        className="gap-2 text-muted-foreground hover:text-foreground hover:bg-muted px-2.5"
      >
        <Search className="w-4 h-4" />
        <span className="text-xs hidden md:inline">جستجو</span>
        <kbd className="hidden md:inline text-xs bg-muted border border-border rounded px-1 py-0.5 font-mono leading-none">
          ⌘K
        </kbd>
      </Button>

      <NotificationBell projectId={projectId} />

    </header>
  )
}
